import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { ServiceRepairResult } from '../models/service-repair-result.model';
import { LatLon } from '../../util/geodesy/latlon';
import { BoundingBox } from '../../util/geodesy/bounding-box';

/**
 * HTTP service for the Service/Repair Finder. Calls the AirportsAPI `~/service-repairs` endpoint. Category
 * facet filtering (Airframe / Avionics / Powerplant / ...) is applied client-side in
 * {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
@Injectable({
  providedIn: 'root'
})
export class ServiceRepairsService extends BusinessFinderService<ServiceRepairResult> {

  protected readonly endpoint = 'service-repairs';

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  protected parse(data: any): ServiceRepairResult {
    return ServiceRepairResult.parse(data);
  }

  getServiceRepairsByLatLon(latlon: LatLon, radius: number): Promise<ServiceRepairResult[]> {
    return this.getByLatLon(latlon, radius);
  }

  getServiceRepairsByBoundingBox(bounds: BoundingBox): Promise<ServiceRepairResult[]> {
    return this.getByBoundingBox(bounds);
  }

  getServiceRepairsByState(state: string): Promise<ServiceRepairResult[]> {
    return this.getByState(state);
  }

  getServiceRepairsBySearchTerm(term: string): Promise<ServiceRepairResult[]> {
    return this.getBySearchTerm(term);
  }
}
